var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.appLoading)?_c('SpinnerContainer',{staticClass:"nested-page-spinner",attrs:{"is-loading":_vm.appLoading}}):_vm._e(),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }